import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import { Typography, Grid, Button } from '@material-ui/core';
import { css } from '@emotion/core';
import { useRootStore } from '../../stores/BridgeProvider';
import Spinner from '../util/Spinner';
import { FlexDiv } from '../styles/styles';
import TopCard from './Widgets/TopCard';
import Activity from './Widgets/Activity';
import UnpaidVouchers from './Widgets/UnpaidVouchers';
import permissionCheck from '../util/PermCheck';
import DashboardJoyride from '../joyrides/DashboardJoyride';
import TopAgents from './Widgets/TopAgents';
import SetupAlert from '../../alerts/SetupAlert';
import IncomeByMonth from './Widgets/IncomeByMonth';
import ReportsWidget from './Widgets/ReportsWidget';
import Checklist from '../onboarding/checklist/Checklist';
import DashboardPref from './DashboardPref';
import RecentCompletedDeals from './Widgets/RecentCompletedDeals';
import TopOpenDeals from './Widgets/TopOpenDeals';

const Container = css`
  max-width: 1200px;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  .titleBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

const RowHolder = css`
  .dynamicRow > div {
    margin: 0px 10px;
  }
  .dynamicRow > div:last-child {
    margin-right: 0px;
  }
  .dynamicRow > div:first-of-type {
    margin-left: 0px;
  }
`;

const Dashboard = () => {
  const { orgStore, authStore, dataStore } = useRootStore();
  const [isLoading, setLoading] = useState(true);
  const [income, setIncome] = useState(null);
  const [stats, setStats] = useState([]);
  const { settings, state } = orgStore;

  // console.log(toJS(dashboardConfig));

  // const displayWidget = widgetName => {
  //   return dashboardConfig.find(p => p.Name === widgetName).Display;
  // };

  useEffect(() => {
    const getDashboardIncome = async () => {
      try {
        const { data } = await authStore.request.get(
          `${process.env.REACT_APP_API}/api/dashboard-income`,
        );
        setIncome(data);
      } catch (e) {
        console.error(e);
      }
    };
    const getDashboardStats = async () => {
      try {
        const { data } = await authStore.request.get(
          `${process.env.REACT_APP_API}/api/dashboard-stats`,
        );
        setStats(data);
      } catch (e) {
        console.error(e);
      }
    };

    const initialActions = async () => {
      const requests = [
        dataStore.retrieveDeals(),
        getDashboardIncome(),
        getDashboardStats(),
      ];
      await Promise.all(requests);
      setLoading(false);
    };
    initialActions();
  }, []);

  if (isLoading || state === 'loading') return <Spinner />;

  const findStat = name => stats.find(({ StatType }) => name === StatType);

  // VOUCHER_S for show net

  return (
    <Observer
      render={() => {
        const { dashboardConfig } = orgStore;
        if (isLoading) return <Spinner />;
        const componentMapping = {
          unpaidVouchers: <UnpaidVouchers key="unpaidVouchers" />,
          grossIncome: <IncomeByMonth key="grossIncome" data={income} />,
          netIncome: <IncomeByMonth key="netIncome" data={income} showNet />,

          syncStatus: <Activity key="syncStatus" />,
          topAgents: <TopAgents key="topAgents" />,
          reports: (
            <ReportsWidget key="reports" dashboardConfig={dashboardConfig} />
          ),
          totalDealsNet: (
            <Grid item lg={3} sm={6} xs={12} key="totalDeals">
              <TopCard stat={findStat('TotalDeals')} showNet />
            </Grid>
          ),
          completeDealsNet: (
            <Grid item lg={3} sm={6} xs={12} key="completeDeals">
              <TopCard stat={findStat('CompleteDeals')} showNet />
            </Grid>
          ),
          unmappedDealsNet: (
            <Grid item lg={3} sm={6} xs={12} key="unmappedDeals">
              <TopCard stat={findStat('UnmappedDeals')} showNet />
            </Grid>
          ),
          atRiskDealsNet: (
            <Grid item lg={3} sm={6} xs={12} key="atRiskDeals">
              <TopCard stat={findStat('AtRiskDeals')} showNet />
            </Grid>
          ),
          totalDealsGross: (
            <Grid item lg={3} sm={6} xs={12} key="totalDeals">
              <TopCard stat={findStat('TotalDeals')} />
            </Grid>
          ),
          completeDealsGross: (
            <Grid item lg={3} sm={6} xs={12} key="completeDeals">
              <TopCard stat={findStat('CompleteDeals')} />
            </Grid>
          ),
          unmappedDealsGross: (
            <Grid item lg={3} sm={6} xs={12} key="unmappedDeals">
              <TopCard stat={findStat('UnmappedDeals')} />
            </Grid>
          ),
          atRiskDealsGross: (
            <Grid item lg={3} sm={6} xs={12} key="atRiskDeals">
              <TopCard stat={findStat('AtRiskDeals')} />
            </Grid>
          ),
          recentComDeals: <RecentCompletedDeals key="recentComDeals" />,
          topOpenDeals: <TopOpenDeals key="topOpenDeals" />,
        };
        return (
          <FlexDiv>
            <SetupAlert />
            <div css={Container} className="dashStep1">
              <div className="titleBox">
                <Typography variant="h2">Dashboard</Typography>

                <DashboardPref />
              </div>
              <Checklist />
              <div css={RowHolder}>
                {dashboardConfig.map((row, index) => (
                  <div
                    key={index}
                    className="dynamicRow"
                    style={{
                      display: 'flex',
                      margin: '1rem 0px',
                    }}
                  >
                    {row.map((widget, j) => {
                      // permissionCheck('VOUCHER_S') &&
                      const newComponent =
                        componentMapping[widget.Name] || null;
                      if (!newComponent) return null;
                      return React.cloneElement(newComponent, {
                        widgetIndex: j,
                        rowIndex: index,
                      });
                    })}
                  </div>
                ))}
              </div>
            </div>
            <DashboardJoyride />
          </FlexDiv>
        );
      }}
    />
  );
};

export default Dashboard;

// {
//   stats.map(stat => (
//     <Grid item lg={3} sm={6} xs={12} key={stat.StatType}>
//       <TopCard stat={stat} showNet={showNet} />
//     </Grid>
//   ));
// }
// Total, complete, unmapped, at risk,

//  to={{
//         pathname: '/deals',
//         state: {
//           filters: [
//             {
//               id: 'title',
//               value: '88',
//             },
//           ],
//         },
//       }}
